<template>
  <div class="common-footer">
    <p>主办单位：二连浩特市驿路跨境电子商务有限公司 版权所有</p>
    <p><a style="color: #fff" href="https://beian.miit.gov.cn" target="_blank">蒙ICP备2025032853号-1</a></p>
    <p><a style="color: #fff; display: flex; align-items: center;" href="https://beian.mps.gov.cn/#/query/websearch?code=15250102000179" target="_blank">
      <img src="@/assets/gongan.png" style="width: 16px; height: 16px;">
      <div style="margin-left: 4px;">蒙公网安备15250102000179号</div>
    </a></p>
  </div>
    
  
</template>
<script>
/**
 * Component footer 页脚组件
 	@author fanjun
 	@props data（必选属性前面带＊，非必选项目请备注默认值）
	@example
	<footer/>
**/
import './index.scss'
export default {
  name: 'Nav',
  components:{
  },
  props:{

  },
  data(){
    return{
    }
  },
  methods: {

  }
}
</script>

